<template>
  <button
    role="checkbox"
    :aria-checked="isActive"
    tabindex="0"
    :class="[ { 'border-neutral-200 bg-white' : !isActive }, { 'border-petrol-500 bg-petrol-50' : isActive }, 'rounded-full border inline-block cursor-pointer leading-5 text-sm max-w-full min-w-0 overflow-hidden']"
    @click="toggle"
  >
    <span class="flex items-center cursor-pointer min-w-0 max-w-full">
      <span :class="[ { 'pr-2' : isActive }, { 'pr-4' : !isActive }, 'py-3 pl-4 truncate min-w-0']">
        <slot />
      </span>
      <span :class="[ { 'pr-2' : isActive }, { 'hidden' : !isActive }, 'shrink-0' ]">
        <UiIcon src="/svg/icons/cancel.svg" width="24" height="24" alt="close" class="fill-neutral-800 rotate-180" />
      </span>
    </span>
  </button>
</template>

<script setup lang="ts">
const props = defineProps({
  id: {
    type: String,
    default: null
  },
  name: {
    type: String,
    default: null
  },
  modelValue: {
    type: [String, Number, Array, Boolean],
    default: null
  },
  value: {
    type: [String, Number, Array],
    default: ''
  },
  trueValue: {
    type: [String, Number, Boolean],
    default: true
  },
  falseValue: {
    type: [String, Number, Boolean],
    default: false
  },
  valuesForRemoval: {
    type: Array,
    default () {
      return []
    }
  },
  error: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits<{(e: 'update:modelValue', value: boolean|string|number|string[]): void}>()

const isActive = computed(() => {
  if (!Array.isArray(props.modelValue) && (props.trueValue !== true || props.falseValue !== false)) {
    return props.modelValue === props.trueValue
  }

  if (!Array.isArray(props.modelValue)) {
    return !!props.modelValue
  }

  if (!Array.isArray(props.value)) {
    return props.modelValue.includes(props.value)
  }

  for (const element of props.value) {
    if (!props.modelValue.includes(element)) {
      return false
    }
  }
  return true
})

const toggle = () => {
  if (!Array.isArray(props.modelValue)) {
    emit('update:modelValue', !isActive.value ? props.trueValue : props.falseValue)
    return
  }

  if (!Array.isArray(props.value) && !props.modelValue.includes(props.value)) {
    emit('update:modelValue', [...props.modelValue, props.value])
    return
  }

  if (!Array.isArray(props.value) && props.modelValue.includes(props.value)) {
    emit('update:modelValue', props.modelValue.filter(x => x !== props.value))
    return
  }

  const localModelValue = props.modelValue.filter(x => !props.valuesForRemoval?.includes(x))

  for (const element of props.value) {
    if (!localModelValue.includes(element)) {
      emit('update:modelValue', [...localModelValue, ...props.value])
      return
    }
  }

  emit('update:modelValue', localModelValue.filter(x => !props.value?.includes(x)))
}
</script>

